export const normalizeLng = (lng: number): number => {
  let normLng = lng % 360
  if (normLng < -180) normLng += 360
  if (normLng > 180) normLng -= 360
  return normLng
}
